// HomePage.js
import React from 'react';
import Hero from '../components/Hero';
import MediaSection from '../components/MediaSection';
import FeaturedCourses from '../components/FeaturedCourses';
import Testimonials from '../components/Testimonials';
import PreFooterCTA from '../components/PreFooterCTA';



const HomePage = () => {
  return (
    <div>
      <Hero />
      <MediaSection />
      <FeaturedCourses />
      <Testimonials />
      <PreFooterCTA />

    </div>
  );
};

export default HomePage;
